import React from "react";
import Textbox from "../../../../common/textbox/Textbox.js";
import Input from "../../../../common/input/Input.js";
import Col from "../../../../common/grid/Col.js";
import Row from "../../../../common/grid/Row.js";
import AttachmentUploader from "../../../../common/attachment/AttachmentUploader.js";
import ImageUpload from "../../../../common/image/ImageUpload.js";

const DescriptionBlock = props => {
  return (
    <Row _no-grow-first _gap-16>
      <ImageUpload
        uploadText="Upload"
        apply={props.onPhotoUpload}
        photoUrl={props.photoUrl}
      />
      <Col _bottom-16>
        <div>
          <label htmlFor="attachment_name" className="key">
            Name:
          </label>
          <Input
            name="name"
            value={props.projectName}
            onChange={props.onChange}
            ph="Project Name"
          />
        </div>
        <div>
          <label htmlFor="attachment_name" className="key">
            Description:
          </label>
          <Textbox
            name="description"
            value={props.description}
            onChange={props.onChange}
            ph="Project Description / Business Idea"
          />
        </div>

        <AttachmentUploader name="description_attachment" typeId="1" />
      </Col>
    </Row>
  );
};

export default DescriptionBlock;



// WEBPACK FOOTER //
// ./src/components/main/projects/_form-blocks/DescriptionBlock.js